﻿import {withUppercase} from "../../../../hocs/withUppercase";
import {CardItemLabelWithGray} from "./CardItemLabelWithGray";

export const CardItemLabelWithGrayUppercase = withUppercase(CardItemLabelWithGray);
